module.exports = __webpack_public_path__ + "static/media/img_liveliness.468c84ec.svg";